var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartAdd = function SvgCartAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.75,
    d: "M37.18 37.74v9.66c0 7.48 6.07 13.55 13.55 13.55s13.55-6.07 13.55-13.55v-9.66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.75,
    d: "M73.45 14.9h-46.9l-11.7 10.68h70.3zM85.15 61.18V25.72M14.85 25.72v49.81c0 5.29 4.29 9.58 9.58 9.58h35.91"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.57,
    cy: 76.18,
    r: 17.17,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M66.77 76.18h17.61M75.57 84.99V67.38"
  })));
};
export default SvgCartAdd;